import request from '../../axios';

const getPromotedAdvertisement = async (guid?: string) => {
  const {data}: {data: PromotedAdvertisementData} = await request.get(
    `api/v2/store/promoted-advertisement/${guid}`,
  );
  return data;
};

export default getPromotedAdvertisement;
